import { render, staticRenderFns } from "./BaseAsideNavItemLink.vue?vue&type=template&id=46041683&scoped=true&"
import script from "./BaseAsideNavItemLink.vue?vue&type=script&lang=js&"
export * from "./BaseAsideNavItemLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseAsideNavItemLink.vue?vue&type=style&index=0&id=46041683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46041683",
  null
  
)

export default component.exports